var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgreementgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.625L3 15.375C3 15.7202 3.42533 16 3.95 16H21.05C21.5747 16 22 15.7202 22 15.375V6.625C22 6.27982 21.5747 6 21.05 6L3.95 6C3.42533 6 3 6.27982 3 6.625Z",
    stroke: "#C99071",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6H8.375V12L6.6875 10.5L5 12V6Z",
    fill: "#C99071",
    stroke: "#C99071",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H17.75M14 14.25H20",
    stroke: "#C99071",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreementgrade);
export default __webpack_public_path__ + "static/media/Agreementgrade.e50f115761becbb0f38cf99b3e7ae3fb.svg";
export { ForwardRef as ReactComponent };